import Manage from "..";
import { AiOutlinePlus } from "react-icons/ai";
import { useEffect, useState } from "react";
import fetchAllModels from "../../../services/fetchAllModels";
import { FiEdit } from "react-icons/fi";
import UpdateModel from "./components/UpdateModel";

export default function AllModels() {
  const [selected, setSelected] = useState<any>(null);
  const [models, setModels] = useState<any>([]);
  const [updateVisible, setUpdateVisible] = useState(false);

  const handleFetchModels = async () => {
    const response = await fetchAllModels();
    setModels(response);
  };

  const handleHideModal = () => {
    setUpdateVisible(false);
  };

  useEffect(() => {
    handleFetchModels();
  }, []);
  return (
    <Manage
      title={"Models"}
      subtitle={"All"}
      description={"List of all models"}
      actions={<></>}
    >
      <div className="mb-4 p-4">
        <div className="grid grid-cols-12 gap-4">
          {models?.map((model: any, index: number) => (
            <div className="col-span-12 sm:col-span-2 border p-4" key={index}>
              <div className="flex flex-col justify-center items-center">
                <div className="w-60 h-48 flex justify-center items-center">
                  <img
                    src={
                      `${model?.image}` ||
                      "../../../assets/images/logo-vertical.png"
                    }
                    width={180}
                    height={150}
                    alt=""
                  />
                </div>
                <div className="flex  justify-between">
                  <div className="">{model.name}</div>
                  {/* <div className="">
                    <button
                      onClick={() => {
                        setSelected(model);
                        setUpdateVisible(true);
                      }}
                    >
                      <FiEdit />
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
        <UpdateModel
          selected={selected}
          isVisible={updateVisible}
          setVisible={setUpdateVisible}
          hideModal={handleHideModal}
        />
      </div>
    </Manage>
  );
}
